import React, { PureComponent } from 'react';
import styled from "styled-components";
import { color, themeType, typo } from '../../styles/style';
import TextAtom from '../atoms/TextAtom';

const TitleFlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  height: auto;
  justify-content: flex-start;
  align-items: flex-end;
  margin: 0 0 45px 0;
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
  width:100%;
  max-width: 100%;
  justify-content: center;
  text-align: center;
    `}
`;
const TitleFlexBoxOuter = styled.div`
  display: flex;
  flex-direction: q${(props) => props.flexDirection || "row"};
  justify-content: ${(props) => props.justifyContent || "center"};
  height: ${(props) => props.height || "100%"};
  width: ${(props) => props.width || "100%"};
  margin: ${(props) => props.margin || "0px 0px"};
  padding: ${(props) => props.padding || "0 0"};
  background: ${(props) => props.background};
  align-items: ${(props) => props.alignItem};
  border-radius: ${(props) => props.borderRadius};
  flex-wrap: wrap;
`;

class TitleMolcule extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            
        }
    }

    render() {
        return (
          <TitleFlexBoxOuter  id={this.props.id}>
            <TitleFlexBox>
              <TextAtom
                text={this.props.text}
                typo={typo.header.h2}
                color={color(themeType.dark).text.primary}
              />
              <TextAtom
                margin="0 0 0 18px"
                text={this.props.subtitleText}
                typo={typo.subTitle.s1}
                color={color(themeType.dark).text.placeholder}
              />
            </TitleFlexBox>
          </TitleFlexBoxOuter>
        );
    }
}

export default TitleMolcule